/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Stack, Paper, Typography, Divider, Grid, Box } from "@mui/material";
import HistoryIcon from '@mui/icons-material/History';
import { Formik } from "formik";
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import pickBy from "lodash/pickBy";
import identity from "lodash/identity";
import LogsModal from "./LogsModal";

import Switch from "../../../components/form/SwitchDetail";
import InputText from "../../../components/form/InputTextDetail";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import Skeleton from "../../../components/form/Skeleton";
import validator from "./validator";
import { useCanView } from "../../../config/hook/UserPermissions";

import { getClientId } from "../../../store/masters/thunk/client/getId";
import { postClient } from "../../../store/masters/thunk/client/post";
import { putClient } from "../../../store/masters/thunk/client/put";
import { getLog } from "../../../store/config/thunk/log/getAll";

const NewEdit = ({ setBtns }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [__] = useTranslation("client");
  const [searchParams] = useSearchParams();
  const [openModal, setOpenModal] = useState(false);
  const { id } = useParams();
  const [showNoti, setShowNoti] = useState({
    open: false,
    msg: "",
    variant: "error",
    action: "post",
  });
  const [alert, setAlert] = useState({
    open: false,
    title: "",
    subtitle: "",
    type: "",
  });
  const [isMount, setIsMount] = useState(false);
  const canView = useCanView();

  const current = useSelector((state) => state.masters.client.detail);
  const put = useSelector((state) => state.masters.client.put);
  const post = useSelector((state) => state.masters.client.post);

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" });
  };

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (
          <ul>
            {map(get(err, "ValidationError", []), (item) => (
              <li>{`• ${item}`}</li>
            ))}
          </ul>
        ),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert,
      });
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert,
      });
    }
  };

  useEffect(() => {
    if (get(put, "isSuccess", false)) {
      setShowNoti({ open: true, msg: "", variant: "success", action: "put" });
    }
    if (get(put, "isReject", false)) {
      setError(get(put, "error", {}), "put");
    }
    if (get(post, "isSuccess", false)) {
      setShowNoti({ open: true, msg: "", variant: "success", action: "post" });
    }
    if (get(post, "isReject", false)) {
      setError(get(post, "error", {}), "post");
    }
  }, [post, put]);

  useEffect(() => {
    if (searchParams.get("from") !== "new") {
      if (!!id) {
        let Screen = "CLIENTES/"
        dispatch(getLog({page: 1,maeId: String(id), screen: String(Screen)}))
        dispatch(getClientId({ id }));
      }
    }
  }, [dispatch, id, searchParams.get("from")]);

  const onSubmit = (values) => {
    const idClient = id;
    const whitOutNulls = pickBy(values, identity);
    if (idClient) {
      dispatch(putClient({ idClient, ...whitOutNulls }));
    } else {
      dispatch(postClient(whitOutNulls));
    }
  };

  const initialValues = {
    isActive: id ? get(current, "data.isActive", "") === 1 ? true : false : true,
    customerId: id,
    name: id ? get(current, "data.name", "") : "",
    state: id ? get(current, "data.state", "") : "",
    city: id ? get(current, "data.city", "") : "",
    address: id ? get(current, "data.address", "") : "",
    municipality: id ? get(current, "data.municipality", "") : ""
  };

  useEffect(() => {
    setBtns(
      <Stack
        className="mr-6"
        direction="row"
        spacing={2}
        justifyContent="flex-end"
      >
        <Button
          className="w-[150px] min-w-[150px]"
          variant="outlined"
          color="secondary"
          startIcon={< HistoryIcon/>}
          onClick={() => {
            if (canView("MAESTROS/CLIENTES/LOGS", "watch")) {
              setOpenModal(true)
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para ver las modificaciones en clientes.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
          }}
        >
         Ver Cambios
        </Button>
        <Button
          className="w-[100px] min-w-[100px]"
          variant="outlined"
          color="secondary"
          onClick={() => navigate("/masters/clients")}
          disabled={get(put, "isLoading")}
        >
          {__(`action.cancel`)}
        </Button>
      </Stack>
    );
  }, [get(put, "isLoading")]);

  return (
    <div>
      {get(current, "isLoading") && !isMount ? (
        <Skeleton />
      ) : (
        <Formik
          initialValues={initialValues}
          validationSchema={validator(__)}
          onSubmit={onSubmit}
        >
          {(formik) => (
            <form id="form-client" onSubmit={get(formik, "handleSubmit")}>
              <Paper className="mt-4">
                <Stack
                  className="p-4"
                  direction="row"
                  spacing={2}
                  justifyContent="space-between"
                >
                  <Typography component="h4" variant="h4">
                    {__(`labels.1`)}
                  </Typography>
                  <Switch formik={formik} name="isActive" __={__} />
                </Stack>
                <Divider />
                <Box className="p-4">
                  <Grid container spacing={{ xs: 2, md: 3 }}>
                    <Grid item xs={12} sm={6}>
                      <InputText
                        formik={formik}
                        name="customerId"
                        label={__(`form.customerId.label`)}
                        disabled={get(post, "isLoading", false)}
                        readOnly={get(post, "isLoading", false)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputText
                        formik={formik}
                        name="name"
                        label={__(`form.name.label`)}
                        disabled={get(post, "isLoading", false)}
                        readOnly={get(post, "isLoading", false)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        className="pt-4"
                        component="p"
                        variant="bmr"
                        color="text.lite"
                      >
                        {__(`labels.3`)}
                      </Typography>
                    </Grid>
                    {/*} <Grid item xs={12} sm={6} md={12}> Para que se vea en toda la pantalla*/}
                    <Grid item xs={12} sm={6}>
                      <InputText
                        formik={formik}
                        name="address"
                        label={__(`form.address.label`)}
                        disabled={get(post, "isLoading", false)}
                        multiline
                        rows={4}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputText
                        formik={formik}
                        name="city"
                        label={__(`form.city.label`)}
                        disabled={get(post, "isLoading", false)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputText
                        formik={formik}
                        name="municipality"
                        label={__(`form.municipality.label`)}
                        // disabled={get(post, "isLoading", false)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputText
                        formik={formik}
                        name="state"
                        label={__(`form.state.label`)}
                        disabled={get(post, "isLoading", false)}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </form>
          )}
        </Formik>
      )}
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <LogsModal
        __={__}
        open={openModal}
        close={() => setOpenModal(false)}
      />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
    </div>
  );
};

export default NewEdit;
